export default "__VITE_ASSET__315ac362__"